window.addEventListener('load', () => {
  //@ts-ignore
  window.dataLayer = window.dataLayer || []
  function gtag() {
    //@ts-ignore
    window.dataLayer.push(arguments)
  }
  gtag('js', new Date())

  gtag('config', 'G-NNZDGGCMMK')
})
